import React, { useState, useEffect } from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import TablaGeneral from "../../../components/TablaGeneral";
import Loader from "../../../components/Loader";
import configTable from "../../../hook/configTable";

const CategoriasPlatilloPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState([])

  const eliminarItem = (id) => {
    console.log('eliminarItem', id);
    setIsLoading(true);
    try {
      fetch(`/api/product-categories/${id}`,{
        method: "DELETE"
      })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setDatos([])
        cargarDatos();
      });
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const [datosTabla] = useState({
    titulo: "Categorías de Merch",
    ruta: "/categoria-merch",
    esAgregar: true,
    esEditar: true,
    esEliminar: true,
    eliminar: eliminarItem,
    configTable: configTable
  })

  const [cabecera] = useState([
    { title: "ID", key: "id" },
    { title: "NOMBRE", key: "nombre" },
    { title: "DESCRIPCIÓN", key: "descripcion" },
    { title: "FECHA_ALTA", key: "createdAt", isDate: true },
  ]);

  const cargarDatos = async () => {
    try {
      fetch("/api/product-categories",{
        method: "GET",
        headers:{
          "Content-Type": "application/json",
        }
      })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if(data.status){
          setDatos(data.data);
        }
        setIsLoading(false);
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);
  return (
    <>
      <MasterLayout>
      { isLoading ? <Loader /> : <TablaGeneral datosTabla={datosTabla} datos={datos} cabecera={cabecera}/> }
      </MasterLayout>
    </>
  );
};

export default CategoriasPlatilloPage;
